import {Box, Stack} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";

import '../../css/App.css';
import ContentDetail from "./ContentDetail";
import SeatDetail from "./SeatDetail";
import ContextMenuButton from "./ContextMenuButton";
import ChildDetailsChip from "../common/ChildDetailsChip";
import { LOOKUP_SESSION_WITH_CHILDREN_DETAILS, LOOKUP_SESSION_WITH_RECORDING_AND_HEALTH_DATA } from "../../queries/GraphQLQueries";
import ChildBriefChip from "../common/ChildBriefChip";
import SessionHealthDetail from "./SessionHealthDetail";
import { MAX_MEMBER_CHIPS_TO_DISPLAY, SESSION_HEALTH_DATA_POLLING_RATE_IN_SECONDS } from "../../constants/SessionConstants";
import {FULL_DISPLAY_CHIP_STYLE} from "../../helpers/SessionHealthChipStylesHelper";

export default function SessionDetails({session, contextId, onContextMenuClick, onChildDetailsDrilledInto, options, showChildDetailLabel}) {
    const [children, setChildren] = useState([]);
    const [isChildChipIconHoveredOver, setIsChildChipIconHoveredOver] = useState(false);
    const [sessionHealthDetail, setSessionHealthDetail] = useState();

    const [lookupSession, { loading, error, data }] = useLazyQuery(LOOKUP_SESSION_WITH_CHILDREN_DETAILS, { fetchPolicy: 'network-only' });
    const [lookupSessionHealth, { data: healthData }] = useLazyQuery(LOOKUP_SESSION_WITH_RECORDING_AND_HEALTH_DATA,
        {
            pollInterval: options.enablePollingSessionHealthData ? SESSION_HEALTH_DATA_POLLING_RATE_IN_SECONDS : 0,
            fetchPolicy: 'network-only'
        });

    const childCount = session.bookingsCount;
    const shouldShowChildChips = childCount !== 0 && childCount <= MAX_MEMBER_CHIPS_TO_DISPLAY;
    const shouldShowBriefChildChips = (!isChildChipIconHoveredOver && children?.length === 0) || (isChildChipIconHoveredOver && loading);

    useEffect(() => {
        if (isChildChipIconHoveredOver && childCount > 0 && childCount <= MAX_MEMBER_CHIPS_TO_DISPLAY) {
            lookupSession({ variables: { sessionId: session.id } });
        }
    }, [isChildChipIconHoveredOver, childCount]);

    useEffect(() => {
        lookupSessionHealth({ variables: { sessionId: session.id } });
    }, [session]);

    useEffect(() => {
        if (data && data?.sessionInfo) {
            let childrenInSession = data.sessionInfo.seats.filter(seat => !!seat.booking).map(seat => seat.booking.child);
            setChildren(childrenInSession);
        }
    }, [data]);

    useEffect(() => {
        if (healthData && healthData?.sessionInfo) {
            setSessionHealthDetail(healthData.sessionInfo);
        }
    }, [healthData]);

    return (
        <Stack id={session.id} direction="row" justifyContent={"flex-start"} sx={{zIndex: 1}}>
            { options.enableContextMenu && <ContextMenuButton id={contextId} onContextMenuClick={onContextMenuClick} /> }
            <SeatDetail session={session} />
            <ContentDetail contentInfo={session.contents} />

            {
              options.enableSessionHealthDetailDisplay
              &&
              sessionHealthDetail
              &&
              <SessionHealthDetail session={sessionHealthDetail} options={options} chipStyles={FULL_DISPLAY_CHIP_STYLE} />
            }

            {
              shouldShowChildChips
              &&
              shouldShowBriefChildChips
              &&
              <>
                  {Array(childCount).fill(null).map((_, index) => (
                    <Box sx={{display: 'flex'}}>
                        <ChildBriefChip
                          key={index}
                          isDataLoading={isChildChipIconHoveredOver && loading}
                          handleChipIconHovered={() => setIsChildChipIconHoveredOver(true)}/>
                    </Box>
                  ))}
              </>
            }

            {
              shouldShowChildChips
              &&
              !shouldShowBriefChildChips
              &&
              children?.map(child => {
                  return <Box sx={{display: 'flex'}}>
                      <ChildDetailsChip
                        key={child.id}
                        containsHeader={false}
                        {...{child, onChildDetailsDrilledInto, showChildDetailLabel}} />
                  </Box>;
              })
            }
        </Stack>
    );
}